import React from 'react';
import { useState } from "react";

export const APIStatusContext = React.createContext();

export default function APIStatusProvider({ children }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    return (
        <APIStatusContext.Provider value={{isLoading, setIsLoading, isError, setIsError, errorMessage, setErrorMessage}}>
            {children}
        </APIStatusContext.Provider>
    )
}
